import React, { useState, useEffect, useRef } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import GroupIcon from "@mui/icons-material/Group";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import PublicIcon from "@mui/icons-material/Public";
import Typography from "@mui/material/Typography";
import "./CulLastSection.css";
import image1 from "../../assets/c8.jpg";
import image2 from "../../assets/c4.jpg";
import image3 from "../../assets/c7.jpg";
import image4 from "../../assets/c4.jpg";
import image5 from "../../assets/c5.jpg";
import image6 from "../../assets/c6.jpg";
import image7 from "../../assets/c7.jpg";
import image8 from "../../assets/c8.jpg";
import image9 from "../../assets/c9.jpg";
import icon1 from "../../assets/icon-car1.jpg";
import icon2 from "../../assets/icon-car2.jpg";
import icon3 from "../../assets/icon-car3.jpg";

const timelineData = [
  {
    time: "9:30 am",
    title: "team",
    description: "thinkers, builders, problem-solvers, and innovators",
    icon: icon1,
    gallery: [
      { src: image4, caption: "Team Bonding" },
      { src: image5, caption: "Team Spirit" },
      { src: image6, caption: "Unity" },
    ],
  },
  {
    time: "10:00 am",
    title: "culture",
    description: "that nurtures potential and unlocks possibilities",
    icon: icon2,
    gallery: [
      { src: image1, caption: "Grand Inaugration" },
      { src: image2, caption: "Team collaboration" },
      { src: image3, caption: "Unity" },
    ],
  },
  {
    time: "11:30 am",
    title: "community",
    description: "creating meaningful, lasting impact - for our people, our clients, and the world.",
    icon: icon3,
    gallery: [
      { src: image7, caption: "Collabrative" },
      { src: image8, caption: "Supportive" },
      { src: image9, caption: "Inclusive" },
    ],
  },
];

const CulLastSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  // ✅ HORIZONTAL TIMELINE REF
  const timelineRef = useRef(null);
  const timelineHovered = useRef(false);

  // Image carousel refs
  const carouselRef = useRef(null);
  const carouselHovered = useRef(false);

  // ✅ HORIZONTAL SCROLL ON ACTIVE INDEX CHANGE
  useEffect(() => {
    if (timelineRef.current) {
      const scrollX = activeIndex * 350; // Adjust based on item width
      timelineRef.current.scrollTo({
        left: scrollX,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  // ✅ HORIZONTAL WHEEL HANDLING
  useEffect(() => {
    const timelineEl = timelineRef.current;
    const carouselEl = carouselRef.current;

    const handleTimelineWheel = (e) => {
      if (!timelineHovered.current) return;
      e.preventDefault();
      // ✅ HORIZONTAL SCROLL INSTEAD OF VERTICAL
      timelineEl.scrollLeft += e.deltaY;
    };

    const handleCarouselWheel = (e) => {
      if (!carouselHovered.current) return;
      e.preventDefault();
      carouselEl.scrollLeft += e.deltaY;
    };

    const setHover = (ref, val) => () => (ref.current = val);

    timelineEl?.addEventListener("wheel", handleTimelineWheel, { passive: false });
    timelineEl?.addEventListener("mouseenter", setHover(timelineHovered, true));
    timelineEl?.addEventListener("mouseleave", setHover(timelineHovered, false));

    carouselEl?.addEventListener("wheel", handleCarouselWheel, { passive: false });
    carouselEl?.addEventListener("mouseenter", setHover(carouselHovered, true));
    carouselEl?.addEventListener("mouseleave", setHover(carouselHovered, false));

    return () => {
      timelineEl?.removeEventListener("wheel", handleTimelineWheel);
      timelineEl?.removeEventListener("mouseenter", setHover(timelineHovered, true));
      timelineEl?.removeEventListener("mouseleave", setHover(timelineHovered, false));

      carouselEl?.removeEventListener("wheel", handleCarouselWheel);
      carouselEl?.removeEventListener("mouseenter", setHover(carouselHovered, true));
      carouselEl?.removeEventListener("mouseleave", setHover(carouselHovered, false));
    };
  }, []);

  // ✅ HORIZONTAL SCROLL DETECTION FOR ACTIVE ITEM
  useEffect(() => {
    const timelineEl = timelineRef.current;

    const handleScroll = () => {
      const items = timelineEl?.querySelectorAll(".timeline-item");
      if (!items) return;

      let maxVisibleRatio = 0;
      let mostVisibleIndex = activeIndex;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const containerRect = timelineEl.getBoundingClientRect();

        // ✅ HORIZONTAL VISIBILITY CALCULATION
        const visibleWidth = Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
        const ratio = visibleWidth / rect.width;

        if (ratio > maxVisibleRatio && ratio > 0.5) {
          maxVisibleRatio = ratio;
          mostVisibleIndex = index;
        }
      });

      setActiveIndex(mostVisibleIndex);
    };

    timelineEl?.addEventListener("scroll", handleScroll);
    return () => timelineEl?.removeEventListener("scroll", handleScroll);
  }, [activeIndex]);

  const current = timelineData[activeIndex];

  return (
    <section className="cul-carousel">
      <div className="last_section_heding">
        <p className="culheading">OUR CULTURE</p>
        <p style={{ fontSize: "40px" }}>RUNS DEEP</p>
      </div>

      {/* ✅ HORIZONTAL TIMELINE */}
      <div className="cul-carousel-wrapper">
        <div className="cul-timeline-scroll" ref={timelineRef}>
          <Timeline className="cul-timeline" sx={{ flexDirection: 'row' }}>
            {timelineData.map((item, index) => (
              <TimelineItem
                key={index}
                className={`timeline-item ${index === activeIndex ? "active" : ""}`}
                data-index={index}
              >
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot sx={{ backgroundColor: "transparent", boxShadow: "none" }}>
                    <img src={item.icon} alt="icons" style={{height:"60px",width:"60px"}} />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ minWidth: '200px' }}>
                  <Typography variant="h6">{item.title}</Typography>
                  <Typography>{item.description}</Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </div>
      </div>

      {/* IMAGE CAROUSEL (UNCHANGED) */}
      <div className="cul-image-carousel">
        <div
          className="cul-carousel-track-wrapper"
          ref={carouselRef}
          style={{ transform: `translateX(-${activeIndex * 100}%)`, transition: "transform 0.6s ease" }}
        >
          {timelineData.map((item, index) => (
            <div className="cul-carousel-track" key={index}>
              {item.gallery.map((img, i) => (
                <div className="cul-carousel-card" key={i}>
                  <img src={img.src} alt={`gallery-${i}`} />
                  <div className="cul-carousel-overlay">
                    <p>{img.caption}</p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CulLastSection;
